
import React, { useMemo, useEffect, useState } from "react";
import { Box, Typography, Tabs, Tab, Paper } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Test from "./createTest";
import TestParameters from "./testParameter/TestParameter";
import AddAsset from "./addAssets";

const TestComponent: React.FC = () => {
  const navigate = useNavigate();
  const checkTypeFromStorage = localStorage.getItem("checkType");
  const { tab, id } = useParams<{ tab?: string; id?: string }>();
  const [checkType, setCheckType] = useState<boolean>(
    checkTypeFromStorage ? JSON.parse(checkTypeFromStorage) : false
  );

  const tabConfigs = useMemo(
    () => [
      { label: "Test", key: "create-test" },
      { label: "Add Parameters", key: "create-parameters" },
      { label: "items / tools", key: "add-assets" },
    ],
    []
  );

  const displayedTabs = useMemo(
    () =>
      tabConfigs.filter((t) => !(checkType && t.key === "create-parameters")),
    [tabConfigs, checkType]
  );
  const [activeTabKey, setActiveTabKey] = useState<string>(tabConfigs[0].key);

  const [tabIndex, setTabIndex] = useState<number>(0);
  useEffect(() => {
    const currentKey = tab ?? displayedTabs[0]?.key;
    // fallback to first available tab if current is filtered out
    const validKey = displayedTabs.some((t) => t.key === currentKey)
      ? currentKey
      : displayedTabs[0]?.key;
    setActiveTabKey(validKey);
  }, [tab, displayedTabs]);

  useEffect(() => {
    if (tabIndex >= displayedTabs.length) {
      setTabIndex(displayedTabs.length - 1 >= 0 ? displayedTabs.length - 1 : 0);
    }
  }, [displayedTabs, tabIndex]);
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    const clickedTab = displayedTabs[newValue];
    if (!clickedTab) return;

    navigate(`/test-tab/${clickedTab.key}${id ? `/${id}` : ""}`, {
      replace: true,
    });
    setActiveTabKey(clickedTab.key);
  };

  const renderTabContent = () => {
    // const key = displayedTabs[tabIndex]?.key ?? displayedTabs[0]?.key;
    switch (activeTabKey) {
      case "create-test":
        return (
          <Test
            checkType={checkType}
            setCheckType={setCheckType}
            // goToNextTab={goToNextTab}
          />
        );
      case "create-parameters":
        return <TestParameters />;
      case "add-assets":
        return <AddAsset />;
      default:
        return null;
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Tabs
        // value={tabIndex}
        value={displayedTabs.findIndex((t) => t.key === activeTabKey)}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        allowScrollButtonsMobile
        scrollButtons="auto"
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          "& .MuiTabs-flexContainer": {
            display: "flex",
            gap: 1,
            justifyContent: "start",
          },
          "& .MuiTab-root": {
            color: "#4d4d4dff",
            textTransform: "none",
            fontWeight: "400",
          },
          "& .Mui-disabled": {
            color: "#9e9e9edc !important",
            cursor: "not-allowed",
          },
          "& .Mui-selected": {
            color: "primary.main",
          },
        }}
      >
        {displayedTabs.map((t) => (
          <Tab
            key={t.key}
            label={t.label}
            sx={{ fontSize: ".75rem", pointerEvents: "auto" }}
            disabled={
              (t.key === "add-assets" || t.key === "create-parameters") && !id
            }
          />
        ))}
      </Tabs>

      <Box sx={{ marginTop: "10px" }}>{renderTabContent()}</Box>
    </Paper>
  );
};

export default TestComponent;
